import { Grid } from "@mui/material";
import React, { Fragment } from "react";
import Events from "./Events";
import Tasks from "../Dcp Tutoring/Tasks";
import SessionHistory from "../Dcp Tutoring/SessionHistory";
import MileStone from "../Project Details/MileStone";

const ProjectWorkSpace = ({
    studentId,
    currentService,
    projectData,
    mileStones,
    getMileStones
}) => {
    return (
        <Fragment>
            <Grid container spacing={2}>
                <Grid item md={6}>
                    <Events
                        currentService={currentService}
                        studentId={studentId}
                        subService={projectData.project_id}
                    />
                </Grid>
                <Grid item md={6}>
                    <Tasks
                        label="Active Technical Tasks"
                        fromMentor 
                        isProjectMentor
                        options={mileStones.map((a) => ({
                            value: a.milestone_id,
                            label: a.milestone_name
                        }))}
                        currentService={currentService}
                        studentId={studentId}
                        subService={projectData?.project_id}
                    />
                </Grid>
                <Grid item md={12}>
                    <MileStone
                        fromMentor
                        mileStones={mileStones}
                        getMileStones={getMileStones}
                    />
                </Grid>
                <Grid item md={12}>
                    <SessionHistory
                        currentService={currentService}
                        studentId={studentId}
                        subService={projectData?.project_id}
                        fromMentor
                    />
                </Grid>
            </Grid>
        </Fragment>
    )
}

export default ProjectWorkSpace;